module.exports = __webpack_public_path__ + "static/media/BUSD.6e600144.svg";